export default "__VITE_ASSET___B8JwX82__"